import React from 'react';

import TextBase from './TextBase';
import { TText } from './types';

const BodyExtraSmall = ({ as = 'span', color, strong = false, ...rest }: TText) => (
  <TextBase as={as} kind={strong ? 'body-extra-small-strong' : 'body-extra-small-regular'} color={color} {...rest} />
);

export default BodyExtraSmall;
